/**
 * @generated SignedSource<<21cf9a465b0aa60cf28eafce8146051b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userTracking_viewer$data = {
  readonly transactionsCounter?: {
    readonly submittedTransactions?: number | null;
    readonly confirmedTransactions?: number | null;
    readonly guestCheckoutTransactions: number | null;
  } | null;
  readonly " $fragmentType": "userTracking_viewer";
};
export type userTracking_viewer$key = {
  readonly " $data"?: userTracking_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"userTracking_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "checkoutUserId"
    },
    {
      "kind": "RootArgument",
      "name": "hasCheckoutUserId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_viewer",
  "selections": [
    {
      "condition": "hasCheckoutUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "checkoutUserId"
            }
          ],
          "concreteType": "TransactionsCounter",
          "kind": "LinkedField",
          "name": "transactionsCounter",
          "plural": false,
          "selections": [
            {
              "condition": "hasUserId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "submittedTransactions",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "submitted",
                  "storageKey": null
                },
                {
                  "alias": "confirmedTransactions",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "confirmed",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": "guestCheckoutTransactions",
              "args": null,
              "kind": "ScalarField",
              "name": "guest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ccc2594bb1100b6116146ab8a2ff6863";

export default node;
